export default __webpack_public_path__ + "static/media/enhanced.120ac386.png";